
export const HOME_URL = {
  PROD: 'https://cloud.xizinet.com',
  // PROD: 'http://localhost:9696',
  // PROD: 'https://test-cloud.xizinet.com',
}
